import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminBusinessesContent from "../admin/components/AdminBusinessesContent";

const SupportManagerBusiness = () => {
  return (
    <SupportLayout userRole="SM">
      <AdminBusinessesContent useOwnLayout={true} userRole="SM" />
    </SupportLayout>
  );
};

export default SupportManagerBusiness;
